<template>
  <div class="list-content-row">
    <ul class="content-row" :class="{
        'content-row--content-row-tablet-78': renderData.contentRowTablet78,
        'content-row--content-row-tablet-auto': renderData.contentRowTabletAuto
      }" :style="{ height: renderData?.rowHeight && '78px' }" @click="handleRowClick">
      <li class="content-row__item" :class="[`content-row__item--${col.type}`]"
        :style="{ flex: col.width ? 'none' : '1', width: col.width, 'text-align': col.align }"
        v-for="(col, idx2) of columns" :key="col.id || col.key">

        <template v-if="col.type === 'label'">
          <div class="content-row__item__cell" :class="[{ 'content-row__item__cell--padding-left': idx2 === 0 }]">
            <template v-if="col.render">
              <component :is="col.render" v-bind="{ data, column: col, idx: idx1, expandStatus }"
                @expand="handleExpand" />
              <!-- :key="uuid()" -->
            </template>
            <template v-else>
              <span class="content-row__item__text">{{ data[col.key] }}</span>
            </template>
          </div>
        </template>
        <template v-if="col.type === 'checkbox'">
          <div class="content-row__item__checkbox">
            <n-checkbox v-model:checked="isCheck" />
          </div>
        </template>
        <!-- 刪掉下面這個，用render function -->
        <template v-if="col.type === 'action'">
          <!-- <img src="@/assets/myMusic/icon_more.svg" /> -->
          <more />
        </template>
      </li>
    </ul>

    <div class="other-data">

      <div class="desc" v-if="renderData.moreDesc">

        <p class="desc__text" :class="{
            'desc__text--more': renderData.expandDetail === 'music-detail' && expandStatus.music,
          }">
          <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni, commodi reprehenderit quaerat incidunt tempore
        aperiam pariatur voluptate suscipit excepturi perferendis! -->

          {{ data?.trackDescription || data?.track?.trackDescription || '' }}
        </p>
      </div>

      <div class="extra-info" :class="{ 'extra-info--is-search': renderData.isSearch }" v-if="renderData.showExtraInfo">
        <div class="desc-extra" v-show="listFilter.includes('description')">
          <p class="desc-extra__text" :class="{ 'desc-extra__text--no-spacing': noPaddingPage }">
            {{
              data?.trackDescription ||
              data?.track?.trackDescription ||
              data?.albumDescription ||
              data?.description ||
              ''
            }}
          </p>
        </div>
        <div class="sound-wave" v-show="listFilter.includes('waves')" v-if="trackWave">
          <img class="sound-wave__img" :src="trackWaveSource(trackWave)" ref="soundWaveRef" @click="handlePosition" />
        </div>
        <div class="label-items" v-show="isShowTags">
          <!-- <loading v-show="isLoadingTrackTags" /> -->
          <tag-list :trackUid="data.trackUid" />
        </div>

        <!-- <tag-list :trackUid="data.trackUid" v-show="listFilter.includes('tags') && isShowTags"/> -->
      </div>
    </div>

    <n-collapse-transition :show="renderData.expandDetail === 'list-detail' && expandStatus.detail">
      <list-detail :data="data || []" />
    </n-collapse-transition>
    <!-- <div v-show="renderData.expandDetail === 'list-detail' && expandStatus.detail" >
      <list-detail :data="data || []"  />
    </div> -->
    <n-collapse-transition :show="renderData.expandDetail === 'music-detail' && expandStatus.music">
      <music-detail :data="data || []" />
    </n-collapse-transition>
    <n-collapse-transition :show="renderData.expandDetail === 'note-list' && expandStatus.note">
      <note-list :data="data || []" ref="noteListRef" />
    </n-collapse-transition>
  </div>
</template>

<script>
import { defineComponent, ref, inject, provide, reactive, computed, watch, onMounted } from 'vue';
import { NCheckbox, NCollapseTransition } from 'naive-ui';
import { useRoute } from 'vue-router';
import { v4 as uuid } from 'uuid';
import ListDetail from '@/components/MyMusic/MyMusicList/ListDetail/index.vue';
import More from '@/components/Global/MusicPlayer/Fragment/More.vue';
import MusicDetail from '@/components/MyMusic/MyMusicList/ListDetail/MusicDetail/index.vue';
import NoteList from '@/components/MyMusic/MyMusicList/NoteList.vue';
import LabelItem from '@/components/Global/LabelItem.vue';
import { useSiteStore } from '@/store/site';
import { useMyMusicStore } from '@/store/myMusic';
import imageSource from '@/utils/imageSource';
import trackWaveSource from '@/utils/trackWaveSource';
// import useMusicPlayer from '@/hooks/useMusicPlayer';
// import { searchTracksByUidAPI } from '@/api/getTags';
import { useSearchStore } from '@/store/search';
// import useRequest from '@/hooks/useRequest';
import TagList from '@/components/Global/TagList.vue';
// import { useMusicPlayerStore } from '@/store/musicPlayer';
import { useNewMusicPlayerStore } from '@/store/newMusicPlayer';

export default defineComponent({
  name: 'ListContentRow',
  components: {
    ListDetail,
    NCheckbox,
    More,
    MusicDetail,
    NoteList,
    LabelItem,
    NCollapseTransition,
    imageSource,
    TagList,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    columns: {
      type: Object,
      default: () => ({}),
    },
    idx1: {
      type: Number,
    },
  },
  setup(props) {
    // console.log('props', props);
    // const { handleFromExternalTrack } = useMusicPlayer();
    const newMusicPlayerStore = useNewMusicPlayerStore();
    const route = useRoute();
    const siteStore = useSiteStore();
    const myMusicStore = useMyMusicStore();
    const searchStore = useSearchStore();
    // const musicPlayerStore = useMusicPlayerStore();
    const isCheck = ref(false);
    const noteListRef = ref(null);
    const expandStatus = reactive({
      detail: false,
      music: false,
      note: false,
    });
    const soundWaveRef = ref();

    const uid = computed(() => props.data.trackUid || props.data.albumUid);

    const routeQueryType = computed(() => route.query.type);
    const noPaddingPage = computed(() =>
      [
        'search',
        'my-music-playlists',
        'my-music-search-history',
        'my-music-play-history',
        'my-music-download-history',
      ].includes(route.name));
    const trackWave = computed(() => props.data?.trackWave || props.data?.track?.trackWave);
    const listFilter = computed(() => myMusicStore.listFilter);
    const isShowTags = computed(() => {
      if (route.name === 'search') {
        if (listFilter.value.includes('tags') && ['tracks'].includes(routeQueryType.value)) {
          return true;
        }
        return false;
      }

      if (route.name === 'my-music-playlists') {
        return null;
      }

      if (listFilter.value.includes('tags')) {
        return true;
      }

      return false;
    });
    const labelWith = computed(() => {
      if (props.data?.track?.tags) {
        return props.data.track?.tags
          ?.filter((item) => item.tag?.name)
          .map((item) => ({
            label: item.tag?.name || '',
            tagUid: item.tag?.tagUid || '', // 先隨便寫
          }));
      }

      return (props.data?.tags || []).map((item) => {
        const { name, tagUid } = item;
        return {
          label: name,
          tagUid,
        };
      });
    });

    const renderData = computed(() => inject('listContentConfig', () => ({}))());
    const isLoadingTrackTags = computed(() => inject('isLoadingTrackTags', () => ({}))());
    const musicDetail = inject('musicDetail', {});

    const handleExpand = (key) => {
      expandStatus[key] = !expandStatus[key];
    };

    const handleRowClick = () => {
      // sm-pc 以上透過小箭頭展開
      if (siteStore.deviceType.includes('tablet')) return;

      if (musicDetail.value.mobileExpandKey === 'mobile-music-player' && route.name !== 'my-music-playlists') {
        siteStore.toggleShowMobileMusicPlayer(true);
        // handleFromExternalTrack(props.data.trackUid);
        newMusicPlayerStore.handleSearchTrack(props.data.trackUid);

        return;
      }

      handleExpand(musicDetail.value.mobileExpandKey);
    };

    const globalCheckStatus = inject('isCheckAll');
    const checkStatus = computed(() => globalCheckStatus.value);

    const reloadNoteContent = () => {
      if (renderData.value.expandDetail === 'note-list' && expandStatus.note) {
        noteListRef.value.handleNoteContentRequest();
      }
    };

    // 其他頁面跳轉過來時觸發
    const autoExapnd = () => {
      if (route.name === 'my-music-playlists' && route.query.expandUid) {
        if (props.data.accountPlaylistUid === route.query.expandUid) {
          handleExpand('detail');
        }
      }
    };

    const handlePosition = async (e) => {
      // 點擊位置與左邊界的 x 距離
      const { offsetX } = e;
      // 進度條的長度
      const progressBarLength = soundWaveRef.value.clientWidth;
      // 點擊位置在進度條的百分比
      const clickPersentage = offsetX / progressBarLength;
      const time = props.data.duration * clickPersentage;

      newMusicPlayerStore.handleWavePlay(props.data.trackUid, time);
    };

    provide('reloadNoteContent', reloadNoteContent);
    provide('handleExpand', handleExpand);
    provide('expandStatus', () => expandStatus);
    provide('isFavourite', props.data.isFavourite);
    provide('projectName', props.data.name);

    watch(uid, () => {
      expandStatus.music = false;
      expandStatus.detail = false;
    });

    watch(checkStatus, () => {
      isCheck.value = checkStatus.value;
    });

    // 在相同頁面時觸發
    watch(
      () => route.query,
      () => {
        autoExapnd();
      },
    );

    //
    const expandUid = computed(() => searchStore.expandUid);

    watch(
      () => expandUid.value,
      (newValue) => {
        if (props.data?.albumUid === newValue || props.data?.playlistUid === newValue) {
          handleExpand('detail');
        }
      },
      {
        immediate: true,
      },
    );

    onMounted(() => {
      autoExapnd();
    });

    return {
      isShowTags,
      handleExpand,
      handleRowClick,
      expandStatus,
      isCheck,
      renderData,
      listFilter,
      labelWith,
      noPaddingPage,
      checkStatus,
      imageSource,
      trackWave,
      trackWaveSource,
      uuid,
      noteListRef,
      route,
      isLoadingTrackTags,
      expandUid,
      soundWaveRef,
      handlePosition,
      // isLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
.list-content-row {
  border-radius: 5px;
  // overflow: hidden;
}

.content-row {
  @include flex();
  width: 100%;
  height: 52px;
  @include padding(0 16px);
  cursor: pointer;

  &__item {
    @include flex();

    &__text {
      @include font-style($c-assist6, 14, normal, 0, 26px);
    }

    &__cell {
      width: 100%;

      &--padding-left {
        margin-left: 0px;
        width: 100%;
      }
    }

    &__checkbox {
      width: 100%;
      @include flex(center);
    }
  }
}

.extra-info {
  @include padding(0 40px 0px 46px);

  &--is-search {
    @include padding(0 60px 0px 105px);

    // .desc__text {
    //   padding: 0;
    // }

    // .sound-wave {
    //   padding: 0;
    // }
  }
}

.desc {
  // margin-top: 12px;
  display: none;
  padding-bottom: 16px;

  &__text {
    @include font-style($c-assist4, 14, normal, 0.8px, 18px);
    margin-left: 55px;
  }
}

.desc-extra {
  // margin-top: 12px;
  padding-bottom: 16px;

  &__text {
    @include font-style($c-assist4, 14, normal, 0.8px, 18px);
    margin-left: 50px;

    &--no-spacing {
      margin-left: 0;
    }
  }
}

.sound-wave {
  display: none;

  &__img {
    width: 100%;
    height: 50px;
  }
}

.label-items {
  @include padding(0 0px 16px);
}

// .desc {
//   display: none;
// }

.other-data {
  display: none;
}

@media screen and (min-width: $tablet) {
  .content-row {

    &--content-row-tablet-78 {
      min-height: 78px;
    }

    &--content-row-tablet-auto {
      height: auto;
      // min-height: auto;
    }
  }

  .desc {
    display: inline-block;
    @include padding(0 20px 20px 0);

    &__text {
      @include font-style($c-assist4, 14, 400, 0.7px, 18px);
      @include word-ellipsis(1);

      &--more {
        @include word-ellipsis-unlimited();

      }
    }
  }

  .other-data {
    display: block;
  }
}

@media screen and (min-width: $sm-pc) {
  .content-row {
    min-height: 78px;
    height: auto;
    padding: 0;
    cursor: auto;

    &__item {
      &__cell {
        &--padding-left {
          margin-left: 20px;
        }
      }
    }
  }

  .sound-wave {
    display: block;
    @include padding(0 0px 16px);
    @include optimizeImage();
  }

}
</style>
